import React, { useState } from 'react'

const Tab = () => {
const [activeLink, setActiveLink] = useState("https://wa.me/+447878959620");


  const handleSocialClick = (link) => {
    setActiveLink(link);
  };

  const handleActiveLinkClick = () => {
    if (activeLink) {
      window.open(activeLink, "_blank");
    }
  };
  return (
    <div>
        <div className="support-service">
            <a
                onClick={() => handleSocialClick("https://wa.me/+00000000")}
                className={`support-whatsapp ${
                activeLink === "https://wa.me/+00000000" ? "open" : ""
                }`}
            >
                <img
                src="/assets/images/socialicon/whatsapp.png"
                alt="whatsApp"
                title="WhatsApp"
                />
            </a>

            <a
                // onClick={() => handleSocialClick("https://www.facebook.com/share/g/1Ew9nHVZ5x/")}
                className={`support-whatsapp 
                ${
                // activeLink === "https://www.facebook.com/share/g/1Ew9nHVZ5x/" ? "open" : ""
                activeLink ===  ""
                }
                `}
            >
                <img
                src="/assets/images/socialicon/facebook.png"
                alt="facebook"
                title="Facebook"
                />
            </a>
        </div>

        {/* {activeLink && (
            <div
                onClick={handleActiveLinkClick}
                style={{
                textAlign: "center",
                marginTop: "10px",
                fontSize: "12px",
                cursor: "pointer",
                textDecoration: "underline",
                color: '#ffffff'
                }}
            >
                {activeLink === "https://wa.me/+447878959620"
                ? "+447878959620"
                : "Facebook"}
            </div>
        )} */}
        <div className="support-info">
            <div className="support-detail open">
                <a href="mailto:info@99wicket.live" target="_blank" rel="noreferrer">info@99wicket.live</a>
            </div>
            <div className="support-detail "></div>
            <div className="support-detail "></div>
            <div className="support-detail "></div>
            <div className="support-detail "></div>
            <div className="support-detail "></div>
        </div>
    </div>
  )
}

export default Tab